// import React, { useState } from 'react';
// import './LoginDialog.css';
// import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
// import { Button } from './ui/button.js';
// import { Input } from './ui/input.js';
// import { Label } from './ui/label';
// import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs.js';
// import { User, Lock, Mail } from 'lucide-react';

// const LoginDialog = ({ open, onOpenChange }) => {
//   const [loginData, setLoginData] = useState({ email: '', password: '' });
//   const [signupData, setSignupData] = useState({ name: '', email: '', password: '' });

//   const handleLogin = (e) => {
//     e.preventDefault();
//     console.log('Login attempt:', loginData);
//     onOpenChange(false);
//   };

//   const handleSignup = (e) => {
//     e.preventDefault();
//     console.log('Signup attempt:', signupData);
//     onOpenChange(false);
//   };

//   return (
//     <Dialog open={open} onOpenChange={onOpenChange}>
//       <DialogContent className="login-dialog-content">
//         <DialogHeader>
//           <DialogTitle className="login-dialog-title">
//             Welcome Back
//           </DialogTitle>
//         </DialogHeader>

//         <Tabs defaultValue="login" className="login-dialog-tabs">
//           <TabsList className="login-dialog-tabs-list">
//             <TabsTrigger value="login">Login</TabsTrigger>
//             <TabsTrigger value="signup">Sign Up</TabsTrigger>
//           </TabsList>

//           <TabsContent value="login" className="login-dialog-form-wrapper">
//             <form onSubmit={handleLogin} className="login-dialog-form">
//               <div className="login-dialog-form-group">
//                 <Label htmlFor="login-email">Email</Label>
//                 <div className="login-dialog-input-wrapper">
//                   <Mail className="login-dialog-icon" />
//                   <Input
//                     id="login-email"
//                     type="email"
//                     placeholder="Enter your email"
//                     className="login-dialog-input"
//                     value={loginData.email}
//                     onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="login-dialog-form-group">
//                 <label htmlFor="login-password">Password</label>
//                 <div className="login-dialog-input-wrapper">
//                   <Lock className="login-dialog-icon" />
//                   <input
//                     id="login-password"
//                     type="password"
//                     placeholder="Enter your password"
//                     className="login-dialog-input"
//                     value={loginData.password}
//                     onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
//                     required
//                   />
//                 </div>
//               </div>

//               <button type="submit" className="login-dialog-submit-button">
//                 Sign In
//               </button>
//             </form>
//           </TabsContent>

//           <TabsContent value="signup" className="login-dialog-form-wrapper">
//             <form onSubmit={handleSignup} className="login-dialog-form">
//               <div className="login-dialog-form-group">
//                 <label htmlFor="signup-name">Full Name</label>
//                 <div className="login-dialog-input-wrapper">
//                   <User className="login-dialog-icon" />
//                   <input
//                     id="signup-name"
//                     type="text"
//                     placeholder="Enter your full name"
//                     className="login-dialog-input"
//                     value={signupData.name}
//                     onChange={(e) => setSignupData({ ...signupData, name: e.target.value })}
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="login-dialog-form-group">
//                 <label htmlFor="signup-email">Email</label>
//                 <div className="login-dialog-input-wrapper">
//                   <Mail className="login-dialog-icon" />
//                   <input
//                     id="signup-email"
//                     type="email"
//                     placeholder="Enter your email"
//                     className="login-dialog-input"
//                     value={signupData.email}
//                     onChange={(e) => setSignupData({ ...signupData, email: e.target.value })}
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="login-dialog-form-group">
//                 <label htmlFor="signup-password">Password</label>
//                 <div className="login-dialog-input-wrapper">
//                   <Lock className="login-dialog-icon" />
//                   <input
//                     id="signup-password"
//                     type="password"
//                     placeholder="Create a password"
//                     className="login-dialog-input"
//                     value={signupData.password}
//                     onChange={(e) => setSignupData({ ...signupData, password: e.target.value })}
//                     required
//                   />
//                 </div>
//               </div>

//               <button type="submit" className="login-dialog-submit-button">
//                 Create Account
//               </button>
//             </form>
//           </TabsContent>
//         </Tabs>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default LoginDialog;

import React, { useState } from "react";
import "./LoginDialog.css";
import { useNavigate } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import { toast } from "react-toastify";
import Loading from "../../Loader/Loading";

const LoginDialog = ({ open, onOpenChange }) => {
  const [tab, setTab] = useState("login");
  const [showTerms, setShowTerms] = useState(false);
  const [step, setStep] = useState(1);
  const [islogin, setIsLogin] = useState(false);
  const [issignup, setIsSignup] = useState(false);

  const navigate = useNavigate();

  const [User, setUser] = useState({
    username: "",
    password: "",
  });

  const [Demo, setDemo] = useState({
    companyname: "",
    newusername: "",
    newpassword: "",
    newconfirmpassword: "",
    email: "",
    phno: "",
    url: "",
    size: "",
    agree: false,
  });

  if (!open) return null;

  const handleLogin = async (event) => {
    event.preventDefault();
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/login.php`;
    const formData = new FormData();
    try {
      setIsLogin(true);
      const formData = new FormData();
      formData.append("user_name", User?.username);
      formData.append("password", User?.password);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      // setCredienticals(data);
      if (data.message === "Login successful") {
        setUser({
          username: "",
          password: "",
        });
        const userDetails = {
          username: data.user_name,
          clientcode: data.client_code,
          clientname: data.client_name,
          clientid: data.client_id,
          role: data.role,
          email: data.email,
          id: data.id,
          phone: data.phone_no,
          sub: data.subscriber_id,
          companyname: data.company_name,
          dept: data.dept,
        };
        localStorage.setItem("userdetails", JSON.stringify(userDetails));
        onOpenChange(false);
        if (data.role === "user") {
          navigate("/CU");
        } else if (data.role === "support") {
          navigate("/SU");
        } else {
          navigate("/CM");
        }
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setIsLogin(false);
    }
  };

  const handleSignup = async (event) => {
    event.preventDefault();
    if (!Demo.agree) {
      toast.error("You must agree to the terms and conditions to sign up.");
      return;
    }
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/signup.php`;
    const formData = new FormData();
    try {
      setIsSignup(true);
      if (Demo.newpassword === Demo.newconfirmpassword) {
        const formData = new FormData();
        formData.append("type", "form");
        formData.append("client_id", "");
        formData.append("user_name", Demo?.newusername);
        formData.append("password", Demo?.newpassword);
        formData.append("phone_no", Demo?.phno);
        formData.append("email", Demo?.email);
        formData.append("role", "admin");
        formData.append("company_name", Demo?.companyname);
        formData.append("company_url", Demo?.url);
        formData.append("company_size", Demo?.size);

        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        onOpenChange(false);
        setStep(1);
        if (data.message === "User created successfully") {
          setDemo({
            companyname: "",
            newusername: "",
            newpassword: "",
            newconfirmpassword: "",
            email: "",
            phno: "",
            url: "",
            size: "",
            agree: false,
          });
          alert(data.message);
          setStep(1);
        } else {
          alert(data.error);
          setDemo({
            companyname: "",
            newusername: "",
            newpassword: "",
            newconfirmpassword: "",
            email: "",
            phno: "",
            url: "",
            size: "",
            agree: false,
          });
        }
      } else {
        alert("Password and Confirm Password should be same");
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setIsSignup(false);
    }
  };

  const handleforgotpass = () => {
    navigate("/Forgot");
  };

  return (
    <div
      className="dialog-overlay"
      onClick={() => {
        onOpenChange(false);
        setTimeout(() => setTab("login"), 0);
        setStep(1);
        setDemo({
          companyname: "",
          newusername: "",
          newpassword: "",
          newconfirmpassword: "",
          email: "",
          phno: "",
          url: "",
          size: "",
          agree: false,
        });
      }}
    >
      {islogin && <Loading type="Login" />}
      {issignup && <Loading type="signup" />}

      <div className="dialog" onClick={(e) => e.stopPropagation()}>
        <h2 className="dialog-title">
          {tab === "login" ? "Welcome Back" : "Let’s Build Together"}
        </h2>

        {/* Tab Switcher */}
        <div className="tab-buttons">
          <button
            className={tab === "login" ? "active" : ""}
            onClick={() => {
              setTab("login");
              setStep(1);
              setDemo({
                companyname: "",
                newusername: "",
                newpassword: "",
                newconfirmpassword: "",
                email: "",
                phno: "",
                url: "",
                size: "",
                agree: false,
              });
            }}
          >
            Login
          </button>
          <button
            className={tab === "signup" ? "active" : ""}
            onClick={() => setTab("signup")}
          >
            Sign Up
          </button>
        </div>

        {/* Login Form */}
        {tab === "login" && (
          <form className="form" onSubmit={handleLogin}>
            <label>Email</label>
            <input
              value={User?.username}
              onChange={(e) =>
                setUser((prev) => ({ ...prev, username: e.target.value }))
              }
              required
              placeholder="User ID or Email"
              type="text"
            />

            <label>Password</label>
            <input
              value={User?.password}
              onChange={(e) =>
                setUser((prev) => ({ ...prev, password: e.target.value }))
              }
              required
              placeholder="Password"
              type="password"
            />
            <span className="forgot-password" onClick={handleforgotpass}>
              <a>Forgot Password?</a>
            </span>

            <button type="submit" className="submit-btn">
              Sign In
            </button>

            <div className="signup">
              <p>
                Want to see how it works? Get started with a demo!{" "}
                <span onClick={() => setTab("signup")}>
                  <a>Sign Up</a>
                </span>
              </p>
            </div>
          </form>
        )}

        {/* Signup Form */}
        {tab === "signup" && (
          <form className="form" onSubmit={handleSignup}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              <h4 style={{ margin: 0 }}>
                {step === 1 ? "Personal Details" : "Company Details"}
              </h4>
              {step === 2 && (
                <button
                  type="button"
                  className="submit-btn"
                  style={{ padding: "4px 12px", fontSize: "14px" }}
                  onClick={() => setStep(1)}
                >
                  ← Back
                </button>
              )}
            </div>
            {/* STEP PROGRESS INDICATOR */}
            <div className="step-progress">
              <div className={`step-bar ${step > 1 ? "completed" : "active"}`}>
                {step > 1 && <FaCheck className="bar-icon" />}
              </div>
              <div className={`step-bar ${step === 2 ? "active" : ""}`}></div>
            </div>

            {step === 1 ? (
              <>
                <label>User Name</label>
                <input
                  value={Demo?.newusername}
                  onChange={(e) =>
                    setDemo((prev) => ({
                      ...prev,
                      newusername: e.target.value,
                    }))
                  }
                  required
                  placeholder="User Name"
                  type="text"
                />

                <label>Phone Number</label>
                <input
                  value={Demo.phno}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Allow only digits, limit to 10
                    if (/^\d{0,10}$/.test(value)) {
                      setDemo((prev) => ({ ...prev, phno: value }));
                    }
                  }}
                  required
                  placeholder="Mobile Number"
                  type="tel"
                />

                <label>Password</label>
                <input
                  value={Demo?.newpassword}
                  onChange={(e) =>
                    setDemo((prev) => ({
                      ...prev,
                      newpassword: e.target.value,
                    }))
                  }
                  required
                  placeholder="Password"
                  type="password"
                />

                <label>Confirm Password</label>
                <input
                  value={Demo?.newconfirmpassword}
                  onChange={(e) =>
                    setDemo((prev) => ({
                      ...prev,
                      newconfirmpassword: e.target.value,
                    }))
                  }
                  required
                  placeholder="Confirm Password"
                  type="password"
                />

                {/* NEXT BUTTON with validation */}
                <button
                  type="button"
                  className="submit-btn"
                  onClick={() => {
                    if (
                      !Demo.newusername ||
                      !Demo.newpassword ||
                      !Demo.newconfirmpassword ||
                      !Demo.phno
                    ) {
                      toast.error("Please fill all the required fields.");
                      return;
                    }

                    if (Demo.newpassword !== Demo.newconfirmpassword) {
                      toast.error("Passwords do not match.");
                      return;
                    }

                    // No errors – go to next step
                    setStep(2);
                  }}
                >
                  Next
                </button>
              </>
            ) : (
              <>
                <label>Company Name</label>
                <input
                  value={Demo?.companyname}
                  onChange={(e) =>
                    setDemo((prev) => ({
                      ...prev,
                      companyname: e.target.value,
                    }))
                  }
                  required
                  placeholder="Company Name"
                  type="text"
                />

                <label>Company Email</label>
                <input
                  value={Demo?.email}
                  onChange={(e) =>
                    setDemo((prev) => ({ ...prev, email: e.target.value }))
                  }
                  required
                  placeholder="E-mail"
                  type="email"
                />

                <label>Company Website URL</label>
                <input
                  value={Demo?.url}
                  onChange={(e) =>
                    setDemo((prev) => ({
                      ...prev,
                      url: e.target.value,
                    }))
                  }
                  required
                  placeholder="Enter URL"
                  type="url"
                />

                <label>Select the user</label>
                <select
                  value={Demo?.size}
                  onChange={(e) =>
                    setDemo((prev) => ({
                      ...prev,
                      size: e.target.value,
                    }))
                  }
                  required
                  placeholder="Total user"
                  type="text"
                >
                  <option value="" disabled>
                    Select Size
                  </option>
                  <option value={"1-10"}>1-10</option>
                  <option value={"11-50"}>11-50</option>
                  <option value={"51-100"}>51-100</option>
                  <option value={"200+"}>200+</option>
                </select>

                <label className="terms-label">
                  <input
                    type="checkbox"
                    checked={Demo.agree}
                    onChange={(e) =>
                      setDemo((prev) => ({
                        ...prev,
                        agree: e.target.checked,
                      }))
                    }
                  />
                  I agree to the{" "}
                  <span
                    className="terms-link"
                    onClick={() => setShowTerms(true)}
                  >
                    Terms of Demo Usage
                  </span>
                </label>

                <button type="submit" className="submit-btn">
                  Create Account
                </button>
                <div className="signup">
                  <p>
                    You already have an account?{" "}
                    <span
                      onClick={() => {
                        setTab("login");
                        setStep(1);
                      }}
                    >
                      <a>Sign In</a>
                    </span>
                  </p>
                </div>
              </>
            )}
          </form>
        )}

        {showTerms && (
          <div className="terms-modal">
            <div className="terms-content">
              <h2>Terms of Demo Account Usage</h2>
              <p>
                This demo account is valid for <strong>15 days</strong> only
                from the date of registration. It is strictly intended for{" "}
                <strong>official and evaluation purposes</strong> to help users
                explore the features of our system.
              </p>
              <ul>
                <li>
                  Data provided must be accurate and belong to you or your
                  organization.
                </li>
                <li>
                  Demo accounts are monitored and may be contacted for feedback
                  or validation.
                </li>
                <li>
                  <strong>
                    Illegal, abusive, or harmful activity is strictly prohibited
                  </strong>
                  .
                </li>
                <li>
                  All demo data may be deleted after the demo period without
                  further notice.
                </li>
                <li>
                  By signing up, you agree that we may contact you regarding
                  your demo experience.
                </li>
              </ul>
              <p>
                We are committed to data safety and compliance. If you have
                concerns, please contact our support team.
              </p>
              <button className="close-btn" onClick={() => setShowTerms(false)}>
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginDialog;
